import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { Flex, Spinner } from '@chakra-ui/react';

type Props = {
  children: any;
};

export function ProtectedRoute({ children }: Props) {
  const { user, loading, token } = useAuth() || {};

  if (loading && !token)
    return (
      <Flex direction="column" align="center" mt={20}>
        <Spinner color="brand.400" size="xl" />
      </Flex>
    );
  if (!user || !token) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return children;
}
